import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const WeighBridgeInToFollow = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [driver, setDriver] = useState("");
  const [driverCode, setDriverCode] = useState("");
  const [driversList, setDriversList] = useState([]);
  const [inwardNo, setInwardNo] = useState("");
  const [wbNo, setWbNo] = useState("");
  const [wbName, setWbName] = useState("");
  const [wbData, setWbData] = useState([]);
  const [clerkData, setClerkData] = useState([]);
  const [clerk, setClerk] = useState("");
  const [clerkCode, setClerkCode] = useState("");
  const [wbnoSearch, setWbnoSearch] = useState("");
  const [ticketNo, setTicketNo] = useState("");
  const [wbinData, setWbInData] = useState([]);

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !wbnoSearch) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["OT_WEIGHBRIDGE_NO", "OT_WEIGHBRIDGE_TICKET_NO"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });
    const wb = wbData?.find((value) => value?.WBNAME === wbnoSearch);
    const wbnoFilter = !wbnoSearch || item?.OT_WEIGHBRIDGE_NO === wb?.WBNUMBER;
    return textMatch && wbnoFilter;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1229`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setInwardNo(response?.data[0]?.NEWDOCNO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1264`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWbData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=611`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filteredData = response?.data?.filter(
          (item) => item?.DESIGNATION === "Weighbridge Clerk"
        );
        setClerkData(filteredData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Clerk details:", error);
      });

    //   1228
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1228`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWbInData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Clerk details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1274`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filterData = response?.data?.filter(
          (item) => item?.TICKETINPROCRSSED === null
        );
        setVehiclesList(filterData);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Clerk details:", error);
      });
  };

  // Saving
  async function Save() {
    if (!driver) {
      alert("Kindly Supply the Driver");
      return;
    }

    if (!wbName) {
      alert("Kindly Provide Weighbridge");
      return;
    }

    if (!clerk) {
      alert("Kindly Provide Weighbridge Clerk");
      return;
    }

    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1230`,
        {
          FIRSTSECOND: "FIRST",
          WBTICKETNO: Number(inwardNo),
          WBNUMBER: Number(wbNo),
          TRUCKNO: vehicleNo ? vehicleNo : "",
          DRIVERCODE: driverCode ? driverCode : "",
          CLERKCODE: clerkCode ? clerkCode : "",
          TRUCKEMPTYLOADEDONARRIVAL: "",
          PRODUCTONARRIVAL: "",
          FIRSTWEIGHT: 0,
          FIRSTWEIGHTDATETIME: moment(date).format("YYYY/MM/DD"),
          SECONDWEIGHT: 0,
          SECONDWEIGHTDATETIME: "",
          TRUCKEMPTYLOADEDONDEPARTURE: "",
          PRODUCTONDEPARTURE: "",
          CARGOWEIGHT: 0,
          MULTIPLEWEIGHBRIDGETOFOLLOW: 0,
          PREVIOUSWBTICKETNO: Number(ticketNo),
          VERICATIONNO: 0,
          WORKSHOPGATEPASSNO: 0,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Weighbridge Inward Updated successfully`);
        console.log(`Weighbridge Inward Updated successfully`);
        setShowGateIn(false);
        window.location.reload();
      } else {
        setisloading(false);
        console.error(`Error while saving Weighbridge Inward`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Weighbridge Inward `, error);
    }
  }

  const handleRowClick = (value, index) => {
    const wb = wbData?.find(
      (item) => item?.WBNUMBER === value?.OT_WEIGHBRIDGE_NO
    );

    setWbName(wb?.WBNAME);
    setWbNo(value?.OT_WEIGHBRIDGE_NO);
    setTicketNo(value?.OT_WEIGHBRIDGE_TICKET_NO);
    const filterData = wbinData?.find(
      (item) => item?.WBTICKETNO === value?.OT_WEIGHBRIDGE_TICKET_NO
    );
    setVehicleNo(filterData?.TRUCKNO);
    setDriverCode(filterData?.DRIVERCODE);
    const dri = driversList?.find(
      (item) => item?.DRIVERCODE === filterData?.DRIVERCODE
    );
    setDriver(dri?.DRIVERNAME);
    console.log(filterData);
    setClerkCode(filterData?.WEIGHBRIDGECLERK);
    const clerk = clerkData?.find(
      (item) => item?.["EMPLOYEE CODE"] === filterData?.WEIGHBRIDGECLERK
    );
    setClerk(clerk?.["EMPLOYEE NAME"]);
    setShowGateIn(true);
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Weighbridge In To Follow
        </h1>
        <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        />
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
        <p className="text-red-600 lg:ml-2">Weighbridge :</p>
        <Select
          className="lg:w-64 lg:ml-2"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
          value={
            wbnoSearch
              ? { value: wbnoSearch, label: wbnoSearch }
              : { value: "", label: "Select" }
          }
          onChange={(e) => {
            setWbnoSearch(e.value);
          }}
          options={[
            { value: "", label: "Select" },
            ...wbData?.map((item) => ({
              value: item?.WBNAME,
              label: item?.WBNAME,
            })),
          ]}
        ></Select>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TICKET NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                WEIGHBRIDGE NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                WEIGHBRIDGE NAME
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => {
              const wb = wbData?.find(
                (item) => item?.WBNUMBER === value?.OT_WEIGHBRIDGE_NO
              );
              return (
                <tr
                  key={value?.OT_WEIGHBRIDGE_TO_FOLLOW_INDEX}
                  className="hover:bg-gray-100 cursor-pointer text-[13px]"
                  onClick={() => handleRowClick(value, index)}
                >
                  <td className="py-2 px-4 text-right border border-gray-300">
                    {index + 1}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value?.OT_WEIGHBRIDGE_TICKET_NO || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value?.OT_WEIGHBRIDGE_TRUCK_NO || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value?.OT_WEIGHBRIDGE_NO || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {wb?.WBNAME || "N/A"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[250px] h-[80%] lg:w-[750px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="text-3xl font-bold flex lg:justify-center justify-start">
            WEIGHBRIDGE IN TO FOLLOW
          </h1>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Inward No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-8 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={inwardNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-20">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-20">Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
          </div>

          {/* Row 2 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-12 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-5">Driver :</p>
            <Select
              className="lg:w-56 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driver
                  ? { value: driver, label: driver }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriver(e.label);
                setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERCODE,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>
            <p className="text-red-600 lg:ml-2">Ticket No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={ticketNo}
              readOnly
            ></input>
          </div>

          {/* Row 3 */}

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Weighbridge :</p>

            <input
              className="w-56 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={wbName}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2 mr-1">Weighbridge Clerk :</p>

            <Select
              className="lg:w-56 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                clerk
                  ? { value: clerk, label: clerk }
                  : { value: "", label: "Select Weighbridge Clerk" }
              }
              onChange={(e) => {
                setClerk(e.label);
                setClerkCode(e.value);
              }}
              options={[
                { value: "", label: "Select Weighbridge Clerk" },
                ...clerkData?.map((item) => ({
                  value: item["EMPLOYEE CODE"],
                  label: item["EMPLOYEE NAME"],
                })),
              ]}
            ></Select>
          </div>

          <div className="flex justify-center mt-5">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                await Save();
              }}
            >
              WEIGH IN
            </button>
          </div>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default WeighBridgeInToFollow;
